import { Injectable } from '@angular/core';
import { ApiService } from '@shared/services/api.service';
import { ISummaryReport } from '@shared/interfaces';
import { ResponsibleType, SummaryReportCreate, SummaryReportQuery } from '@monorepo/interfaces';
import { convertQueryToParams } from '@shared/helpers/query-converter';

@Injectable({
    providedIn: 'root'
})
export class SummaryReportService {
    private readonly apiUrl = '/summary-reports';

    constructor(private readonly apiService: ApiService) {}

    public getAll(): Promise<ISummaryReport[]> {
        return this.apiService.get(this.apiUrl + '/all');
    }

    public filter(query: SummaryReportQuery): Promise<ISummaryReport[]> {
        return this.apiService.get(`${this.apiUrl}${convertQueryToParams<SummaryReportQuery>(query)}`);
    }

    public create(item: ISummaryReport): Promise<ISummaryReport> {
        const createDto: SummaryReportCreate = {
            title: item.title,
            description: item.description,
            responsibleType: item.responsibleType as unknown as ResponsibleType
        };
        return this.apiService.post(this.apiUrl, createDto);
    }

    public delete(item: ISummaryReport): Promise<void> {
        return this.apiService.delete(`${this.apiUrl}/${item.id}`);
    }

    public getUploadLink(id: string): Promise<{ link: string }> {
        return this.apiService.get(`${this.apiUrl}/${id}/upload`);
    }

    public getDownloadLink(id: string): Promise<{ link: string }> {
        return this.apiService.get(`${this.apiUrl}/${id}/download`);
    }
}
